/**
 * PLAT-12098 — when a contextual task bar may show at all (epic PLAT-12097,
 * DE1 / DE2). Each bar adds its own element-type check on top.
 *
 * - One selected element (DE1): a multi-selection shows no bar.
 * - The selection is itself top-level (DE1): a photo or text inside a graphics
 *   card gets no bar, because the card's chip is that selection's control and
 *   the sidebar routes it to the card. Two controls for one selection — a bar
 *   for the leaf and a chip for its card — was the drift this rule ends.
 * - Not while playing (DE2): the bar would cover the picture being watched.
 *
 * Pure, so every host (Creator Studio, the clip preview) can call it.
 */
export interface BarGateInput {
  activeElementIds: readonly string[];
  /** The source's top-level elements (only `id` is read). */
  topLevelElements: ReadonlyArray<{ id?: unknown }> | undefined;
  isPlaying: boolean;
}

export const isBarTarget = ({
  activeElementIds,
  topLevelElements,
  isPlaying,
}: BarGateInput): boolean => {
  if (isPlaying || activeElementIds.length !== 1) return false;
  const [activeId] = activeElementIds;
  return !!topLevelElements?.some(element => element.id === activeId);
};
